/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function InfoIcon({ className, size = 'xsmall' }) {
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, viewBox: "0 0 20 20" },
        jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            jsx("circle", { cx: "10", cy: "10", r: "10", fill: "currentColor" }),
            jsx("text", { fill: "#FFF", fontFamily: "SourceSansPro-Bold, Source Sans Pro", fontSize: "12", fontWeight: "bold" },
                jsx("tspan", { x: "8.344", y: "14" }, "i")))));
}
//# sourceMappingURL=InfoIcon.js.map